//
import DetailPayrollHeaders from '@/views/HumanResource/HrPayroll/HrDetailPayrollHeaders'

//
import { RequiredRule } from '@/mixins/reusable_mixins/rules'

//
export default [
    {
        name: 'payment_date',
        type: 'date-field',
        props: {
            label: 'Pago',
            rules: [RequiredRule],
        },
    },
    {
        name: 'payment_period',
        type: 'date-field',
        props: {
            label: 'Periodo',
            pickerProps: {
                type: 'month',
            },
            rules: [RequiredRule],
        },
    },
    {
        name: 'selected',
        type: 'table-field',
        flex: {
            'd-grid': true,
            xs12: true,
        },
        props: {
            headers: DetailPayrollHeaders,
            label: 'Fecha a pagar',
            noDataText: 'Sin liquidaciones de sueldo.',
            noRefresh: true,
            showRemove: true,
        },
        slots: {
            items: 'data-table-items',
        },
    },
]
